import { render, staticRenderFns } from "./LogVirtualAccountContent.vue?vue&type=template&id=b2303d84&lang=pug"
import script from "./LogVirtualAccountContent.vue?vue&type=script&lang=js"
export * from "./LogVirtualAccountContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports